<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "app",
  data() {
    return {
      locale: zhCN,
    };
  },
  methods: {},
  created() {},
  beforeDestroy() {
    if (process.env.VUE_APP_WEB_ENV !== "dev") {
      localStorage.removeItem("userInfo");
    }
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
